import { type VisitOptions } from '@inertiajs/core'
import { createInertiaApp } from '@inertiajs/react'
import { createHooks } from 'hookable'

type InertiaDefaults = NonNullable<Parameters<typeof createInertiaApp>['0']['defaults']>

export const inertiaConfig: InertiaDefaults = {
  future: {
    // preserveEqualProps: true,
    useDataInertiaHeadAttribute: true,
    useDialogForErrorModal: true,
  },
  prefetch: {
    cacheFor: '30s',
  },
  visitOptions: (href, options) => {
    let newOptions = options
    hooks.callHookWith(
      hooks => {
        for (const hook of hooks) {
          newOptions = hook(href, newOptions) as any
        }
      },
      'visitOptions',
      href,
      options,
    )

    return newOptions
  },
}

export const visitOptionsHook = (callback: (href: string, options: VisitOptions) => VisitOptions) =>
  hooks.hook('visitOptions', callback)

const hooks = createHooks<{
  visitOptions: (href: string, options: VisitOptions) => void
}>()
